module.exports = __webpack_public_path__ + "media/images/sp/stores/fuji/fuji_sns_02-0d45f708b4d31df84f49e0bc35854dfa.jpg";